import { Language } from "../languages/labels/language.labels";

export function statusInvitationList(lang: Language): {code: string, display: string}[] {
  return [
    { code: 'pending', display: lang.labels.pending },
    { code: 'accept', display: lang.labels.accepted },
    { code: 'reject', display: lang.labels.rejected },
  ]
}

export function statusInvitationValue(lang: Language, code: string): string {
  let statusInvitation = statusInvitationList(lang).find((item) => (item.code === code))
  return statusInvitation ? statusInvitation.display : lang.labels.undefined
}
